import { configureStore, combineReducers } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import SecureStorage from "react-secure-storage";

import rootReducers from "../reducers";
import rootSaga from "../sagas";

const STORAGE_KEY = "redux-state";

function saveStateToSecureStorage(state: unknown) {
  try {
    const serializedState = JSON.stringify(state);
    SecureStorage.setItem(STORAGE_KEY, serializedState);
  } catch (error) {
    console.error("Erro ao salvar estado no SecureStorage", error);
  }
}

function loadStateFromSecureStorage() {
  try {
    const serializedState = SecureStorage.getItem(STORAGE_KEY);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState as string);
  } catch (error) {
    console.error("Erro ao carregar estado do SecureStorage", error);
    return undefined;
  }
}

async function loadInitialState() {
  const cachedState = loadStateFromSecureStorage();
  return cachedState || {};
}

const rootReducer = combineReducers(rootReducers);
const sagaMiddleware = createSagaMiddleware();

export type StoreType = ReturnType<typeof configureStore>;

export const setupStore = async (): Promise<StoreType> => {
  const preloadedState = await loadInitialState();

  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: false,
        serializableCheck: false,
      }).concat(sagaMiddleware),
    preloadedState,
  });

  store.subscribe(() => {
    const state = store.getState();
    saveStateToSecureStorage(state);
  });

  sagaMiddleware.run(rootSaga);

  return store;
};
